import type { ConfigType } from '@plone/registry';
import { getCurrentStyleByName } from '@kitconcept/volto-light-theme/helpers/helpers';

type apiExpanderInherit = {
  match: string;
  GET_CONTENT: string[];
  querystring:
    | { [key: string]: string }
    | ((
        config,
        querystring: { config: ConfigType; querystring: object },
      ) => { [key: string]: string });
};

export default function install(config: ConfigType) {
  // config.settings.slate.useLinkedHeadings = false;
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['en', 'de'];
  config.settings.defaultLanguage = 'de';
  config.settings.navDepth = 2;
  // config.settings.matomoSiteId = 21;
  // config.settings.matomoUrlBase = 'https://analytics.saw-leipzig.de/';

  config.settings.styleClassNameExtenders.push(
    ({ data, classNames }: { data: any; classNames: Array<string> }) => {
      const currentBlockWidth =
        getCurrentStyleByName(
          config.blocks.widths,
          'blockWidth:noprefix',
          data,
        ) || 'layout';
      if (currentBlockWidth) {
        // remove existing block width class if any
        const filteredClassNames = classNames.filter(
          (className) => !className.startsWith('has--block-width--'),
        );
        return [
          ...filteredClassNames,
          `has--block-width--${currentBlockWidth}`,
        ];
      }
      return classNames;
    },
  );

  config.settings.DSGVOBanner = {
    ...(config.settings.DSGVOBanner || {}),
    tracker: {
      type: 'matomo',
      id: 4, //config.settings.matomoSiteId,
      urlBase: 'https://analytics.saw-leipzig.de/', //config.settings.matomoUrlBase,
    },
    modules: ['tracking', 'youtube', 'google'],
    showBanner: true,
    showTechnicallyRequired: true,
    cssClasses: {
      bannerAgreeButton: 'branded medium-green',
      bannerAdjustButton: 'branded medium-green inverse',
    },
    privacy_url: { de: '/de/datenschutz', en: '/de/datenschutz' },
  };

  return config;
}
